import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const AboutPage = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ padding: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          ScholarMaps - Explore the Landscape of Academic Knowledge
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutPage;
